import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import CardSlider2 from '../components/Slider/CardSlider2'
import Page from '../layout/Page';

const careersFeatures = [
  {
      id: 1,
      category: "Growth",
      title: "Shoora is where creativity meets action!",
      description: "A hub for innovation, where ideas come to life and initiative is celebrated. Learn, grow, and thrive in a workplace that empowers you every step of the way!",
      image: "https://images.pexels.com/photos/7562349/pexels-photo-7562349.jpeg?auto=compress&cs=tinysrgb&w=600",
      link: "#",
      linkText: "View Jobs",
  },
  {
      id: 2,
      category: "CSR",
      title: "Turn your social concerns into meaningful action with Shoora!",
      description: " Work with us to create a lasting impact in the fleet industry and beyond. Together, we uplift lives, empower communities, and drive change. Join us in shaping a better future—because your efforts matter!",
      image: "https://images.pexels.com/photos/7562349/pexels-photo-7562349.jpeg?auto=compress&cs=tinysrgb&w=600",
      link: "#",
      linkText: "See our Initiatives (Direct user to CSR)",
  },
 

];

const Careers = () => {
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    "title": "Software Engineer",
    "description": "Shoora Technologies is looking for a skilled Software Engineer to join our growing team. Work on innovative projects in the telematics industry, collaborate with experts, and make a meaningful impact.",
    "identifier": {
      "@type": "PropertyValue",
      "name": "Shoora Technologies",
      "value": "SE123"
    },
    "hiringOrganization": {
      "@type": "Organization",
      "name": "Shoora Technologies",
      "sameAs": "https://www.shoora.com",
      "logo": "https://images.shoora.com/logo.png"
    },
    "industry": "Telematics",
    "employmentType": "FULL_TIME",
    "jobLocation": {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Shoora Technologies",
        "addressLocality": "Gurugram",
        "addressRegion": "Delhi-NCR",
        "postalCode": "10001",
        "addressCountry": "IN"
      }
    },
    "baseSalary": {
      "@type": "MonetaryAmount",
      "currency": "INR",
      "value": {
        "@type": "QuantitativeValue",
        "value": "70000",
        "unitText": "YEAR"
      }
    }
  };
  return (
    <Page 
    title="Careers at Shoora | Join Our Team of Innovators"
      description="Discover a vibrant, inclusive, and entrepreneurial culture at Shoora Technologies. Explore exciting career opportunities, drive innovation, and make an impact."
      keywords="Shoora careers, work at Shoora, job openings, inclusive workplace, telematics careers, software engineer jobs, CSR initiatives"
      structuredData={structuredData}
    >
      <div className='careers-hero' 
      >
        <img src="https://images.pexels.com/photos/3856042/pexels-photo-3856042.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt=""  />
        <div className="row position-absolute  align-items-end p-lg-5 w-100" style={{ top: '150px' }}>
          <div className="col col-12  px-lg-5">
            <p className="fs-6 text-dark mt-5 fw-bold">

            </p>
            <h1 className='text-light mb-4'>
            Experience a vibrant, inclusive, and entrepreneurial culture where YOU come first. Build a career that makes a difference.   <i className="text-lora">At Shoora, we grow together!</i>
            </h1>

            <div className="d-flex pb-5 px-5 px-lg-0">
              <button className="btn btn-outline-light btn-lg px-5 border-3 rounded-5">View current openings {" "} <i class="fa-solid fa-arrow-up-right-from-square"></i></button>
            </div>
          </div>
        </div>
      </div>
    
      <div className='my-5'>
        <div className="container">
          <div className="section-header">
            <h2>Drive your own thoughts to reality</h2>
          </div>
        </div>
        <CardSlider2 data={careersFeatures}/>
      </div>
      <div>
        <h1 className='text-center mb-5  p-5 mx-lg-5' style={{ fontSize: "55px" }}>Wondering what it’s like to join us? <i className="text-accent text-lora">
        Here’s what to expect!</i></h1>
        <div className="row align-items-center mb-5 row-cols-1 row-cols-lg-2">
          <div className="col p-0">
            <img src="https://images.pexels.com/photos/3182750/pexels-photo-3182750.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="" style={{ height: '550px', width: '100%', objectFit: 'cover', borderRadius: "0 20px 20pc 0" }} />
          </div>
          <div className="col">
            <p className='fs-3 p-5 pb-3 text-lora'
            >
              <i>"At Shoora, we seek bold innovators shaping the future of telematics. Here, your ideas matter, your growth is prioritized, and a fun, open workplace fuels collaboration and action!"</i>
            </p>
            <div className="px-5 pb-3"><h5>Manav Lohia</h5>
              <h6>CEO</h6></div>
            <Link className='mx-5 btn btn-outline-dark btn-lg rounded-5 border-3 '>What we're looking for {" "}<i class="fa-regular fa-circle-play"></i></Link>


          </div>
        </div>
        <div className="row align-items-center mb-5 row-cols-1 row-cols-lg-2 p-0">

          <div className="col align-items-center">

            <p className='fs-3 p-5 pb-3 text-lora'
            >
              <i>"As a software engineer, I get to shape the future of the industry. With incredible managers supporting me, Shoora is the perfect place to create meaningful impact!            "</i>
            </p>
            <div className="px-5 pb-3"><h5>Rohit Khurana</h5>
              <h6>Sr. Software Developer</h6></div>
            <Link className='mx-5 btn btn-outline-dark btn-lg rounded-5 border-3 '>What we're looking for {" "}<i class="fa-regular fa-circle-play"></i></Link>

          </div>
          <div className="col p-0">
            <img src="https://images.pexels.com/photos/3182750/pexels-photo-3182750.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="" style={{ height: '550px', width: '100%', objectFit: 'cover', borderRadius: "20pc 0px 0px 20px" }} />
          </div>
        </div>
      </div>
      <hr className='border-warning border-5' />
      <div className="container my-5">
        <div className="row row-cols-1 row-cols-lg-2">
          <div className="col">
            <h2 className="text-dark pe-5 fs-1">
            Join a culture of innovators driving meaningful change. 
            </h2>
          </div>
          <div className="col">
            <p className='fs-4'>
            You’re great at what you do—work with a company that empowers you to reach your full potential!

            </p>
            <Link className=' btn btn-outline-dark btn-lg rounded-5 border-3 '>See all jobs {" "}<i class="fa-solid fa-square-arrow-up-right"></i></Link>

          </div>
        </div>
      </div>
    </Page>
  )
}

export default Careers